import { useTranslation } from "react-i18next";
import "./BdHomeList.scss";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import newRequest from "../../../utils/newRequest";
import { motion } from "framer-motion";
import { GridLoader, ScaleLoader } from "react-spinners";
import { IoDocumentTextSharp } from "react-icons/io5";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import { IoIosRefresh } from "react-icons/io";
import { MdAdd, MdAlternateEmail, MdArrowBackIos, MdClose, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    TablePagination,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
} from "@mui/material";
import { getCssValue, initCap } from "../../../utils/genericFunctions";
import { FiSearch } from "react-icons/fi";
import { CiImageOn } from "react-icons/ci";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar";

const BdHomeList = () => {
    const { t } = useTranslation();
    const socket = useSelector((state) => state.socket.socket);
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const parts = location.pathname.split("/");
    const showBack = location.state?.showBack || "N";
    const [reportGroupArray, setReportKeysArray] = useState(["all-opportunities"]);
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedOpportunity, setSelectedOpportunity] = useState(null);
    const [opportunities, setOpportunities] = useState([]);
    const [selectedBizdevMenu, setSelectedBizdevMenu] = useState(null);
    const [bizdevMenus, setBizdevMenus] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentOpportunityPage, setCurrentOpportunityPage] = useState(0);
    const [mainTitle, setMainTitle] = useState("Documents");

    const getDocumentType = () => {
        if (parts[2] === "oppo") {
            return "Opportunity";
        } else if (parts[2] === "quotereq") {
            return "QuoteRequest";
        } else if (parts[2] === "quote") {
            return "Quote";
        } else {
            return "Opportunity";
        }
    };


    const handleOpportunityPageChange = (event, newPage) => {
        setCurrentOpportunityPage(newPage);
    };

    const handleOpportunityRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentOpportunityPage(0);
    };

    const filteredOpportunities = opportunities?.filter(
        (row) =>
            row?.pl_risk_note_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row?.pl_op_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row?.pl_op_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row?.pl_op_phone_no?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginatedOpportunities = filteredOpportunities?.slice(
        currentOpportunityPage * rowsPerPage,
        currentOpportunityPage * rowsPerPage + rowsPerPage
    );


    const handleSearchOpportunities = async () => {
        try {
            setIsLoading(true);
            if (searchTerm) {
                const res = await newRequest.post("/uwPolicy/search", {
                    search_input: searchTerm,
                    result_limit: 100,
                    pl_type: getDocumentType(),
                    pl_subagent_ent_code: currentUser?.usr_entity_code
                });
                setOpportunities(res.data);
            } else {
                fetchOpportunities();
            }
        } catch (error) {
            console.error("Error searching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchOpportunities = async () => {
        try {
            setIsLoading(true);
            const res = await newRequest.post("/uwPolicy/findAll", {
                result_limit: 50,
                pl_type: getDocumentType(),
                pl_subagent_ent_code: currentUser?.usr_entity_code
            });
            setOpportunities(res.data);
            setSelectedOpportunity(res.data[0]);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchMenu = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Biz Dev Home Menu" });
            setBizdevMenus(res.data);
            setSelectedBizdevMenu(res.data[0]);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getDocumentType();
        fetchOpportunities();
        fetchMenu();
        if (parts[2] === "oppo") {
            setMainTitle(t('opportunities'));
        } else if (parts[2] === "quotereq") {
            setMainTitle(t('quoteRequests'));
        } else if (parts[2] === "quote") {
            setMainTitle(t('quotes'));
        } else {
            setMainTitle(t('opportunities'));
        }
    }, [parts[2]]);

    return (
        <motion.div
            className="bd-home-list"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader className="scaler-loader" />
                </div>
            ) : (
                <div className="list-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <h1 className="page-title">{mainTitle}</h1>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#0f766e5d"
                                endIcon={<IoIosRefresh />} onClick={fetchOpportunities}>
                                {t('refresh')}
                            </CustomLoadingButton>
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#2563EB"
                                endIcon={<IoDocumentTextSharp />}
                                onClick={() => setReportsDialogOpen(true)}>
                                {t('reports')}
                            </CustomLoadingButton>
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#0ea5a4"
                                tooltip={"Add new"}
                                endIcon={<MdAdd />}
                                onClick={() => navigate(`/uw/${getDocumentType()?.toLowerCase()}/new`)}
                            >
                                {t('new')}  {t(getDocumentType()?.toLowerCase())}
                            </CustomLoadingButton>
                            {/* This part shows if the menu was opened from home screen */}
                            {showBack === "Y" && <hr className="separator-v" />}
                            {showBack === "Y" &&
                                <span className="back-icon" onClick={() => navigate(-1)}>
                                    <MdArrowBackIos size={24} />
                                </span>}
                        </div>
                    </div>
                    <div className="bd-summary-wrapper">
                        <div className="content-wrapper">
                            <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                        <TableHead className="tablehead">
                                            <TableRow className="tablerow">
                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                    #
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                                    <span>{t('no').toUpperCase()}</span>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                    <div className="search-input-wrapper" style={{ width: "100%" }}>
                                                        <FiSearch className="search-input-icon" />
                                                        <input
                                                            className="search-input"
                                                            type="text"
                                                            placeholder={`${t('search')} ${t(getDocumentType()?.toLowerCase())}`}
                                                            value={searchTerm}
                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') handleSearchOpportunities();
                                                            }}
                                                        />
                                                        {searchTerm?.length > 0 && (
                                                            <MdClose
                                                                onClick={async (e) => {
                                                                    try {
                                                                        setSearchTerm("");
                                                                        await fetchOpportunities();
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                className="search-input-icon"
                                                            />
                                                        )}
                                                        {searchTerm?.length === 0 && (
                                                            <span className="search-input-icon" />
                                                        )}
                                                    </div>
                                                </TableCell>
                                                <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                    <span></span>
                                                </TableCell>
                                                <TableCell className="table-cell center" style={{ maxWidth: "200px" }}>
                                                    <span>{t('status')}</span>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="tablebody">
                                            {paginatedOpportunities?.map((row, index) => (
                                                <TableRow
                                                    key={row._id}
                                                    className={`${selectedOpportunity?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                    onClick={() => {
                                                        try {
                                                            setSelectedOpportunity(row);
                                                            navigate(`/uw/${getDocumentType()?.toLowerCase()}/${row._id}`, { state: row });
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                >
                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                        {currentOpportunityPage * rowsPerPage + index + 1}
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                                                        <span className="sub-title">{row?.pl_risk_note_no}</span>
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                        <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                                                            <div className='current-user-avatar' style={{ width: "100%", alignItems: "center", justifyContent: "flex-start" }}>
                                                                <div className="user-wrapper" style={{ width: "100%", alignItems: "center", justifyContent: "flex-start" }}>
                                                                    {row?.insured_details_xx?.ent_photo_url ?
                                                                        <img src={row?.insured_details_xx?.ent_photo_url} alt="" className='avatar' />
                                                                        :
                                                                        <InitialsAvatar
                                                                            name={row?.insured_details_xx?.ent_name || row?.pl_op_name || ""}
                                                                            size={30}
                                                                            currentTheme={currentTheme}
                                                                        />
                                                                    }
                                                                    <div className="user-org-view" style={{ width: "100%" }}>
                                                                        <span className="sub-title nowrap">{row?.insured_details_xx?.ent_name || row?.pl_op_name} </span>
                                                                        <span style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", gap: "10px" }}>
                                                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "3px", flex: "1" }} >
                                                                                <MdOutlineNumbers className="icon" />  <h1 className="sub-title xrsmall">{row?.insured_details_xx?.ent_code}</h1>
                                                                            </span>
                                                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "3px", flex: "2" }} >
                                                                                <MdAlternateEmail className="icon" />  <h1 className="sub-title xrsmall">{row?.insured_details_xx?.ent_email || row?.pl_op_email || "Unspecified"}</h1>
                                                                            </span>
                                                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "3px", flex: "1" }} >
                                                                                <MdPhone className="icon" /> <h1 className="sub-title xrsmall">{row?.insured_details_xx?.ent_phone_no || row?.pl_op_phone_no || "Unspecified"}</h1>
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                                        <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                                                            <span className={`status ${getCssValue(row?.pl_op_priority)}`} style={{ width: "2px" }} />
                                                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                                                <span className="sub-title">{row?.pl_op_priority}</span>
                                                                <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.document_age_xx}</span>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className="table-cell center" style={{ maxWidth: "200px" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px", width: "100%" }}>
                                                            <span className={`sub-title xrsmall status ${getCssValue(row?.pl_status)}`}>{row?.pl_status}</span>
                                                            <span className="sub-title xrsmall soft" style={{ fontSize: "10px" }}>{initCap(row?.bizunit_name_xx)}</span>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    {opportunities?.length > rowsPerPage &&
                                        <TablePagination
                                            rowsPerPageOptions={[10]}
                                            rowsPerPage={rowsPerPage}
                                            onRowsPerPageChange={handleOpportunityRowsPerPage}
                                            component="div"
                                            count={opportunities?.length}
                                            rows={opportunities}
                                            page={currentOpportunityPage}
                                            onPageChange={handleOpportunityPageChange}
                                        />}
                                </TableContainer>
                            </div>
                        </div>
                        {/* <div className="right-wrapper">
                            <div className="right-content">
                                <div className="options-list">
                                    {bizdevMenus?.map((row) => (
                                        <span
                                            key={row._id}
                                            className={`${selectedBizdevMenu?._id === row._id
                                                ? "single-option active"
                                                : "single-option"
                                                }`}
                                            onClick={async () => {
                                                try {
                                                    setSelectedBizdevMenu(row);
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <h1 className="sub-title">{row?.sys_name}</h1>
                                            <h1 className="sub-title soft">{row?.sys_desc}</h1>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            )}
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={reportGroupArray}
                                documentData={{
                                    docNo: "1",
                                    docId: "1",
                                    docType: "Opportunity",
                                    format: "xlsx",
                                    entity_code: "",
                                    date_fm: "",
                                    date_to: "",
                                    status: "",
                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
        </motion.div>
    )
}


export default BdHomeList;